// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__Nqr74","ripple":"styles_ripple__eYwSy"};